import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './EmptySearchResult.styles.css';

import { ReactComponent as EmptySearchIcon } from '../../assets/images/global/empty-search.svg';

const EmptySearchResult = ({searchTerm, resetSearchFn}) => {
    const { t } = useTranslation();

    return(
        <div className='cm-empty-search-container d-flex py-5 px-3 justify-content-center text-center align-items-center col-12'>
            <div>
                <EmptySearchIcon />
                <div className='cm-empty-search-content'>
                    <p className='fw-semibold text-blue-700 my-0 pb-2'>{t("nothing_found_for")} {searchTerm}</p>
                    <p className='cm-empty-search-sh fw-medium text-blue-gray-500 my-0 pb-2 cm-sm-txt'>{t("you_can_modify_search")}</p>
                    {!!resetSearchFn && <span className='fw-medium cm-clear-search-btn d-inline-block mt-3 cm-sm-txt text-blue-800 cm-pointer' onClick={resetSearchFn}>{t("clear_search_query")} <FontAwesomeIcon icon={regular("angle-right")} /></span>}
                </div>
            </div>
        </div>
    )

}

export default EmptySearchResult;